import { useMemo } from 'react';
import Typography from '@mui/material/Typography';

import { EntityCardGrid } from '../browse/EntityCardGrid';
import { PageContainer } from '../layout/PageContainer';
import { mobileSearchModels } from '../helpers/mobile-search-models';
import { getBrandIcon } from '../../domain/brandIcons';

export function BrandList() {
  const brands = useMemo(() => mobileSearchModels.map(([brandName]) => brandName), []);

  return (
    <PageContainer>
      <Typography variant="h4" gutterBottom>
        Browse by brand
      </Typography>
      <Typography color="text.secondary" sx={{ mb: 4 }}>
        Pick a brand to see the models we track price history and specs for.
      </Typography>
      <EntityCardGrid
        items={brands}
        getHref={(brand) => `/cars/${encodeURIComponent(brand)}`}
        searchPlaceholder="Search brands..."
        emptyMessage="No brands match your search."
        itemNounPlural="brands"
        getIcon={getBrandIcon}
      />
    </PageContainer>
  );
}
